import React from "react";
import { dateFormator } from "../../utils";
import { Link } from "react-router-dom";
import Divider from "../Common/Divider";

const Timeline = ({ data = [] }) => {
  //data sort date new date firsst
  data.sort((a, b) => new Date(b.taskDate) - new Date(a.taskDate));
  return (
    <div className="w-full overflow-x-auto grid grid-flow-col auto-cols-[550px] py-10 items-stretch scrollbar-thin">
      {data.map((item, index) => (
        <div key={index} className="flex flex-col gap-10">
          <div
            className={`flex-1 shadow-lg flex gap-5 items-center rounded-lg overflow-hidden pr-5 ${index === 0
              ? "ml-4 mr-10"
              : index === data.length - 1
                ? "ml-10 mr-4"
                : "mx-10"
              }`}
          >
            <div className="bg-primary text-white w-20 self-stretch flex flex-col justify-center items-center flex-shrink-0">
              <h4 className="leading-none ">
                {dateFormator(item.taskDate, "daysAgoNum") ?? 0}
              </h4>
              <div className="text-xs capitalize">days ago</div>
            </div>
            <div className="flex flex-col justify-center py-2 overflow-hidden">
              <h5 className="text-nowrap text-base font-semibold truncate">{item.task}</h5>
              <div className="text-sm text-gray-500 flex gap-1 line-clamp-1 truncate whitespace-nowrap">
                <span>{item.taskBy}</span>-<span>{item.designation}</span>
              </div>
              {item?.applicant && item?.applicant != "N/A" && <div className="text-sm text-linkblue flex gap-1 line-clamp-1 truncate whitespace-nowrap">
                Applicant: <span>{item.applicant}</span>
              </div>}
              {item?.source && <div className="text-sm text-linkblue flex gap-1 line-clamp-1 truncate whitespace-nowrap">
                Source: <span>{item.source}</span>
              </div>}
              {item?.jobPostId && <div className="text-sm text-linkblue flex gap-1 line-clamp-1 truncate whitespace-nowrap">
                Job Code: <span>{item.jobPostId}</span>
              </div>}
              {item?.recruiter && <div className="text-sm text-linkblue flex gap-1 line-clamp-1 truncate whitespace-nowrap">
                Recruiter: <span>{item.recruiter}</span>
              </div>}
              {item?.account && (item?.account != "-" && item?.account != "N/A") && <div className="text-sm text-linkblue flex gap-1 line-clamp-1 truncate whitespace-nowrap">
                Account: <span>{item.account}</span>
              </div>}
            </div>
          </div>
          <div className="flex justify-center relative">
            <Divider className="flex-1" />
            <div className="absolute top-1/2 -translate-y-1/2 left-1/2 leading-0 bg-white px-3">
              <span className="material-symbols-outlined">arrow_left_alt</span>
            </div>

            {index === data.length - 1 && (
              <div className="absolute top-1/2 -translate-y-1/2 right-0 leading-0 bg-gray-500 w-5 h-5 rounded-full"></div>
            )}
          </div>
          <div className="flex justify-center gap-1">
            <div className="bg-primary-50 border-[1px] border-primary text-primary w-fit rounded-full px-5 py-1 text-sm flex justify-center gap-1 whitespace-nowrap">
              <span>{dateFormator(item.taskDate, "day")}</span>   
              <span>
                {item.displayDate || item.taskDate || dateFormator(item.taskDate, "day-shortMonth-year-time-utc")}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Timeline;
